import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { APP_BASE_CONFIG } from "../components";
import { IApiConfig, IConfig } from "./api.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class ConfiguracioService {
  private apiUrl = `${this.SharedProperties.baseUrlService()}/MOE/services/configuracio/`;
  private configuracio: IConfig;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $http: angular.IHttpService
  ) { }

  // Load configuration and cache it
  init(): angular.IPromise<IConfig> {
    return this.$http.get<IApiConfig[]>(`${this.apiUrl}getConfig?`)
      .then((response) => {
        const data = response.data[0];
        this.configuracio = {
          ...data,
          cursActual: `${data.anyActual} - ${parseInt(data.anyActual, 10) + 1}`,
          cursPreinscripcio: `${parseInt(data.anyActual, 10) + 1} - ${parseInt(data.anyActual, 10) + 2}`,
          geoServerUrl: data.adrecaGeoserver,
          geoServerUrlPreinscripcio: `${data.adrecaGeoserver.substring(0, data.adrecaGeoserver.length - 5)}/wfs?`,
          pilotoOcultacioInclusiva: data.pilotoOcultacioInclusiva === '1',
          ...APP_BASE_CONFIG,
        };
        return this.configuracio;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return null;
      });
  }

  // Get cached configuration
  getConfiguracio(): IConfig {
    return this.configuracio;
  }
}

angularJsApp.service(AppServicesEnum.CONFIGURACIO_SERVICE, ConfiguracioService);